import { TCustomerDetails } from '@/services/types/TransactionData';
import { TTransactionHistory } from '../types/TransactionHistory';

export const getTeamMember = (data: TTransactionHistory) => {
  if (!data.details?.customer?.avatar || !data.details?.customer) {
    null;
  }

  return {
    avatarUrl: data.details?.customer?.avatar,
    name: generateName(data.details?.customer)
  };
};

const generateName = (customer: TCustomerDetails | undefined) => {
  if (!customer) {
    return;
  }

  return `${customer.firstName} ${customer.lastName}`;
};
